export const state = {
  CHANNELS: 'channels',
  CHANNELS_BY_COLLECTION: 'channelsByCollection',
  USERS_BY_ID: 'usersById',
  MESSAGES: 'messages',
  ACTIVE_CHANNEL: 'activeChannel',
  ACTIVE_COLLECTION_ID: 'activeCollectionId',
  POLLING_INTERVAL_ID: 'pollingIntervalId',
  LAST_FETCHED_AT: 'lastFetchedAt',
  FEED: 'feed',
  CHANNEL_READ_AT: 'channelReadAt',
  CHAT_PANEL_OPEN: 'chatPanelOpen',
  CHAT_PANEL_WIDTH: 'chatPanelWidth',
  ACTIVE_COLLECTION: 'activeCollection',
  COLLECTION_MEMBERS: 'collectionMembers',
  NEW_CONVERSATION_MODE: 'newConversationMode',
  SCROLL_TARGET_MESSAGE_ID: 'scrollTargetMessageId',
};

export const getters = {
  CHANNELS: 'channels',
  CHANNELS_BY_COLLECTION: 'channelsByCollection',
  USERS_BY_ID: 'usersById',
  MESSAGES: 'messages',
  ACTIVE_CHANNEL: 'activeChannel',
  FEED: 'feed',
  UNREAD_FEED: 'unreadFeed',
  CHAT_PANEL_OPEN: 'chatPanelOpen',
  CHAT_PANEL_WIDTH: 'chatPanelWidth',
  ACTIVE_COLLECTION: 'activeCollection',
  COLLECTION_MEMBERS: 'collectionMembers',
  NEW_CONVERSATION_MODE: 'newConversationMode',
  SCROLL_TARGET_MESSAGE_ID: 'scrollTargetMessageId',
};

export const mutations = {
  SET_CHANNELS: 'setChannels',
  SET_CHANNELS_FOR_COLLECTION: 'setChannelsForCollection',
  MERGE_USERS: 'mergeUsers',
  SET_MESSAGES: 'setMessages',
  APPEND_MESSAGES: 'appendMessages',
  SET_ACTIVE_CHANNEL: 'setActiveChannel',
  SET_ACTIVE_COLLECTION_ID: 'setActiveCollectionId',
  SET_POLLING_INTERVAL_ID: 'setPollingIntervalId',
  SET_LAST_FETCHED_AT: 'setLastFetchedAt',
  SET_FEED: 'setFeed',
  SET_CHANNEL_READ_AT: 'setChannelReadAt',
  MARK_CHANNELS_READ: 'markChannelsRead',
  SET_CHAT_PANEL_OPEN: 'setChatPanelOpen',
  SET_CHAT_PANEL_WIDTH: 'setChatPanelWidth',
  SET_ACTIVE_COLLECTION: 'setActiveCollection',
  SET_COLLECTION_MEMBERS: 'setCollectionMembers',
  SET_NEW_CONVERSATION_MODE: 'setNewConversationMode',
  SET_SCROLL_TARGET_MESSAGE_ID: 'setScrollTargetMessageId',
};

export const actions = {
  FETCH_CHANNELS: 'fetchChannels',
  CREATE_CHANNEL: 'createChannel',
  FIND_OR_CREATE_DM: 'findOrCreateDm',
  ADD_CHANNEL_MEMBERS: 'addChannelMembers',
  LEAVE_CHANNEL: 'leaveChannel',
  SET_ACTIVE_CHANNEL: 'setActiveChannel',
  FETCH_MESSAGES: 'fetchMessages',
  POST_MESSAGE: 'postMessage',
  EDIT_MESSAGE: 'editMessage',
  DELETE_MESSAGE: 'deleteMessage',
  START_POLLING: 'startPolling',
  STOP_POLLING: 'stopPolling',
  FETCH_FEED: 'fetchFeed',
  FETCH_FEED_CONTEXT: 'fetchFeedContext',
  MARK_CHANNEL_READ: 'markChannelRead',
  MARK_ALL_READ: 'markAllRead',
  MARK_CHANNELS_READ: 'markChannelsRead',
  OPEN_CHAT: 'openChat',
  CLOSE_CHAT: 'closeChat',
  SET_CHAT_WIDTH: 'setChatWidth',
  SET_ACTIVE_COLLECTION: 'setActiveCollection',
  FETCH_MEMBERS: 'fetchMembers',
  ENTER_NEW_CONVERSATION: 'enterNewConversation',
  EXIT_NEW_CONVERSATION: 'exitNewConversation',
  NAVIGATE_TO_MESSAGE: 'navigateToMessage',
};
